import type * as React from 'react'

import * as HoverCard from '@radix-ui/react-hover-card'

import styles from './EditorTooltip.module.css'

import type { JSX } from 'react'

export const TooltipButton = ({
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement>): JSX.Element => (
  <button
    {...props}
    className={
      className ? `${styles.tooltipButton} ${className}` : styles.tooltipButton
    }
  />
)

export const TooltipText = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLSpanElement>): JSX.Element => (
  <span
    {...props}
    className={
      className ? `${styles.tooltipText} ${className}` : styles.tooltipText
    }
  />
)

export const EditorTooltip = ({
  children,
  trigger,
}: {
  children: React.ReactNode
  trigger: React.ReactNode
}): JSX.Element => {
  const container =
    document.querySelector<HTMLElement>('.editor-container') ?? document.body

  return (
    <HoverCard.Root>
      <HoverCard.Trigger asChild>{trigger}</HoverCard.Trigger>
      <HoverCard.Portal container={container}>
        <HoverCard.Content className={styles.popoverContent}>
          {children}
          <HoverCard.Arrow className={styles.arrow} />
        </HoverCard.Content>
      </HoverCard.Portal>
    </HoverCard.Root>
  )
}
